import { LocationState, Path, History } from 'history';
import React  from 'react';
import { useTranslation } from 'react-i18next';
import {
  NavLink as ReactNavLink,
  NavLinkProps,
  useHistory as reactUseHistory,
} from 'react-router-dom';

export function useHistory<HistoryLocationState = (LocationState & LocationWithSystemPath)>(): History<HistoryLocationState> {
  const [url] = useTranslation('url');
  const history = reactUseHistory<HistoryLocationState>();
  const pushTranslatedPath = (path: Path, state?: HistoryLocationState): void => {
    history.push(url(path), state ? {...state, systemPath: path} : ({systemPath: path} as HistoryLocationState));
  };
  return { ...history, push: pushTranslatedPath };
}

export const NavLink: React.FC<
  NavLinkProps & { to: string,  className?: string }
> = ({ to, ...props }) => {


  return (
      <ReactNavLink className={props.className}
                    to={{ pathname: to, state: { systemPath: to } }} {...props}>
        {props.children}
      </ReactNavLink>
  );
};

export interface LocationWithSystemPath {
  systemPath?: string
}